module.exports = __webpack_public_path__ + "static/media/ctca5.abbbee74.png";